import { Dependency } from './dependency.interface';
import { DependencyDto } from './dependency.dto';

export class DependencyMapper {
  static fromDto(raw: DependencyDto): Dependency {
    return {
      dependenciaId: raw.dependenciaId ?? raw.dependencia_ID ?? raw.Dependencia_ID ?? raw.id ?? 0,
      detalle: raw.detalle ?? raw.Detalle ?? '',
      codigo: raw.codigo ?? raw.Codigo ?? '',
      isDisponible: (raw.isDisponible ?? raw.estado ?? raw.IsDisponible ?? false) as boolean,
      padreId: (raw.padreId ?? raw.padre_ID ?? raw.Padre_ID ?? null) as number | null,
      dtFechaCreacion: raw.dtFechaCreacion ?? raw.DtFechaCreacion,
      dtFechaActualizacion: raw.dtFechaActualizacion ?? raw.DtFechaActualizacion,
      dtFechaAnulacion: (raw.dtFechaAnulacion ?? raw.DtFechaAnulacion ?? null) as string | null
    };
  }

  static fromDtoList(list: DependencyDto[] | Dependency[]): Dependency[] {
    return Array.isArray(list)
      ? list.map(item => DependencyMapper.fromDto((item ?? {}) as DependencyDto))
      : [];
  }
}
